let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cc1Au")).then(() => parcelRequire('godCI'));